import { Pipe, PipeTransform } from '@angular/core';
import { formaterAvecUnite, PALIERS_ENERGIE, PALIERS_PUISSANCE, PALIERS_DEVISE, PALIERS_CO2 } from '../Services/format';

/** Formate une valeur en kWh en choisissant automatiquement kWh/MWh/GWh/TWh. */
@Pipe({ name: 'energieUnite', standalone: true })
export class EnergieUnitePipe implements PipeTransform {
  transform(valeur: number | null | undefined, chiffres = 4): string {
    return formaterAvecUnite(valeur, PALIERS_ENERGIE, chiffres);
  }
}

/** Formate une valeur en kW en choisissant automatiquement kW/MW/GW/TW. */
@Pipe({ name: 'puissanceUnite', standalone: true })
export class PuissanceUnitePipe implements PipeTransform {
  transform(valeur: number | null | undefined, chiffres = 4): string {
    return formaterAvecUnite(valeur, PALIERS_PUISSANCE, chiffres);
  }
}

/** Formate une valeur en k€ en choisissant automatiquement k€/M€/Md€. */
@Pipe({ name: 'deviseUnite', standalone: true })
export class DeviseUnitePipe implements PipeTransform {
  transform(valeur: number | null | undefined, chiffres = 4): string {
    return formaterAvecUnite(valeur, PALIERS_DEVISE, chiffres);
  }
}

/** Formate une valeur en tonnes de CO2 (unité unique, pas de conversion). */
@Pipe({ name: 'co2Unite', standalone: true })
export class Co2UnitePipe implements PipeTransform {
  transform(valeur: number | null | undefined, chiffres = 4): string {
    return formaterAvecUnite(valeur, PALIERS_CO2, chiffres);
  }
}
